import React, { useState, useEffect } from "react";
import EditCampaignForm from "../components/EditCampaignForm";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function EditCampaignPage() {
  const { i18n } = useTranslation();
  const [savedLanguage, setSaveLanguage] = useState();

  useEffect(() => {
    setSaveLanguage(i18n.language);
  }, [i18n.language]);

  const location = useLocation();

  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:w-deflaut md:flex">
        <div className="w-full">
          <a href="/Campaign" className="no-underline">
            <p className="no-underline text-header font-bold my-4 text-ft-light hover:text-ft hover:underline">
              {savedLanguage === "en"
                ? location.state.event.campaignNameEng
                : savedLanguage === "cn"
                  ? location.state.event.campaignNameCn
                  : location.state.event.campaignNameHk}
            </p>
          </a>
          <EditCampaignForm
            campaign={location.state !== null ? location.state.event : ""}
          />
        </div>
      </div>
    </div>
  );
}

export default EditCampaignPage;
